// @owners { team: patients-team }
// eslint-disable-next-line @alto/no-pocky-import
import { FlexColumn, FlexRow, H4, SimpleContainerSection, palette } from '@alto/pocky';
import { faChevronCircleDown } from '@fortawesome/pro-regular-svg-icons/faChevronCircleDown';
import { faChevronCircleUp } from '@fortawesome/pro-regular-svg-icons/faChevronCircleUp';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import autobind from 'autobind-decorator';
import React, { PureComponent } from 'react';

type Props = {
  readonly title: string;
  readonly content: any;
};

type State = {
  open: boolean;
};

export default class CollapsibleSection extends PureComponent<Props, State> {
  state = {
    open: false,
  };

  // @ts-expect-error error TS1270: Decorator function return type 'void | TypedPropertyDescriptor<unknown>' is not assignable to type 'void | (() => void)'
  @autobind
  toggleOpen() {
    this.setState((state) => ({
      open: !state.open,
    }));
  }

  render() {
    const { content, title } = this.props;
    const { open } = this.state;

    return (
      // eslint-disable-next-line @typescript-eslint/unbound-method
      <SimpleContainerSection onClick={this.toggleOpen}>
        <FlexRow>
          <FlexColumn evenlySpaceContent>
            <H4>{title}</H4>
            <FontAwesomeIcon
              icon={open ? faChevronCircleUp : faChevronCircleDown}
              color={palette.grey1}
            />
          </FlexColumn>
          {open ? content : null}
        </FlexRow>
      </SimpleContainerSection>
    );
  }
}
